import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getBankAccountById } from '../../services'
import { BankQueryKeys } from '@/modules/bank/keys'
import { GetBankAccountByIdResponse } from '@/modules/bank/type'

export default function useQueryGetBankAccountById(
	id: string,
	props?: UseBaseQueryOptions<GetBankAccountByIdResponse>,
) {
	return useQuery({
		queryKey: [BankQueryKeys.BankAccountById, id],
		queryFn: () => getBankAccountById(id),
		...props,
	})
}
